import React from 'react';
import { useTranslation } from 'react-i18next';

const benefits = ['reuse', 'modular', 'monitoring', 'support'];

function Advantages() {
  const { t } = useTranslation();

  return (
    <section className="advantages-section" id="Advantages" aria-labelledby="advantages-title">
      <div className="section-container advantages-layout">
        <header className="section-heading advantages-heading">
          <p className="section-eyebrow">{t('advantages.eyebrow')}</p>
          <h2 id="advantages-title">{t('advantages.title')}</h2>
          <p>{t('advantages.introduction')}</p>
        </header>

        <div className="advantages-grid">
          {benefits.map((benefit) => (
            <article className="advantage-card" key={benefit}>
              <span className="advantage-card__marker" aria-hidden="true" />
              <h3>{t(`advantages.items.${benefit}.title`)}</h3>
              <p>{t(`advantages.items.${benefit}.description`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Advantages;
